module.exports = __webpack_public_path__ + "images/sns_campaign_lp/mainvisual-present-2-pc_faa8c1f1749cc3ad067570413a662b26.png";